import { PropertyMapper } from '../../decorators';

export class ProjectNotification {
    @PropertyMapper({ jsonProperty: 'description' })
    public description: number;
}
